import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';

const DocumentViewer = () => {
    // TEST FILES ONLY
    /*const docs = [
        { uri: "https://calibre-ebook.com/downloads/demos/demo.docx", fileType: 'docx', fileName: 'demo.docx' },
        { uri: "https://sample-videos.com/xls/Sample-Spreadsheet-10-rows.xls", fileType: 'xls', fileName: 'Sample-Spreadsheet-10-rows.xls' },
        { uri: "https://sample-videos.com/ppt/Sample-PPT-File-500kb.ppt", fileType: 'ppt', fileName: 'Sample-PPT-File-500kb.ppt' }
     ];*/

    const url = localStorage.getItem('documentUrl');
    const assetName = localStorage.getItem('assetName');

    const getFileExtension = url => {
        const extension = url.split('.').pop();
        return extension;
    };

    const fileExtension = getFileExtension(url);

    const doc = [{ uri: url, fileType: fileExtension, fileName: assetName }];

    return (
        <>
            <DocViewer
                documents={doc}
                pluginRenderers={DocViewerRenderers}
                /*config={{
                header: {
                    disableHeader: false,
                    disableFileName: false,
                    retainURLParams: false
                }
            }}
            theme={{
                primary: "#5296d8",
                secondary: "#ffffff",
                tertiary: "#5296d899",
                textPrimary: "#ffffff",
                textSecondary: "#5296d8",
                textTertiary: "#00000099",
                disableThemeScrollbar: false,
            }}*/
            />
        </>
    );
};

export default DocumentViewer;
